import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted, onBeforeUnmount, nextTick, watch } from 'vue'
import { maps } from '@/plugins/x004-google-maps-loader'
import { watchDebounced } from '@vueuse/core'

import type { google } from 'google.maps'


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'GoogleAddressAutocomplete',
  props: {
  id: {
    type: String,
    required: false,
    default: null,
  },
  name: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: 'text',
  },
  innerElement: {
    type: String,
    default: 'input',
  },
  blockName: {
    type: String,
    default: 'control-input',
  },
  variant: {
    type: Array,
    default: () => [],
  },
  size: {
    type: Array,
    default: () => ['sm'],
  },
  styling: {
    type: String,
    default: 'default',
  },
  appearance: {
    type: Array,
    default: () => [],
  },
  view: {
    type: String,
    default: '',
  },
  iconSize: {
    type: [String, Array],
    default: '2xl',
  },
  startIcon: {
    type: String,
    default: '',
  },
  endIcon: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  value: {
    type: [String, Number, Object, Array],
    default: '',
  },
  invalid: Boolean,
  country: {
    type: Object,
    required: false,
  },
},
  emits: ["update:modelValue", "callback"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();



const props = __props

const emit = __emit

const blockClasses = computed(() => {
  type Classes = Record<string, boolean | string>
  const sizesClass: Classes = props.size.reduce(
    (acc: Classes, size: string) => {
      acc[`${props.blockName}--size_${size}`] = true
      return acc
    },
    {} as Classes
  )
  const appearanceClass: Classes = props.appearance.reduce(
    (acc: Classes, appearance: string) => {
      acc[`${props.blockName}--appearance_${appearance}`] = true
      return acc
    },
    {} as Classes
  )
  const variantClass: Classes = props.variant.reduce(
    (acc: Classes, variant: string) => {
      acc[`${props.blockName}--variant_${variant}`] = true
      return acc
    },
    {} as Classes
  )
  return {
    [`${props.blockName}`]: true,
    [`${props.blockName}--styling_${props.styling}`]: props.styling,
    ...sizesClass,
    ...appearanceClass,
    ...variantClass,
    [`${props.blockName}--view_${props.view}`]: props.view,
    [`is-disabled`]: props.disabled,
    [`is-readonly`]: props.readonly,
    [`is-invalid`]: props.invalid,
  }
})

const internal = ref((props.value && props.value.address) || '')
const position = ref({ lat: 0, lng: 0 })
const autocompleteInput = ref<HTMLElement | null>(null)
const autocomplete = ref(null)

watchDebounced(
  () => props.value?.address,
  (value, old) => {
    if (value !== old) {
      internal.value = (props?.value && props?.value?.address) || ''
      position.value = props?.value
    }
  },
  { deep: true, debounce: 500 }
)

onMounted(async () => {
  await maps().then(setupAutocomplete)
})

function setupAutocomplete() {
  if (autocompleteInput.value) {
    autocomplete.value = new google.maps.places.Autocomplete(
      autocompleteInput.value
    )

    autocomplete.value.addListener('place_changed', async () => {
      const place = autocomplete.value.getPlace()
      internal.value = autocompleteInput.value.value
      const { lat, lng } = await place.geometry.location.toJSON()
      input({ address: autocompleteInput.value.value, lat, lng })
      emit('callback', place)
    })
    if (props.country && props.country.code2) {
      autocomplete.value.setComponentRestrictions({ country: props.country.code2 })
    }

  }
}

async function blur() {
  await nextTick()
  setTimeout(() => {
    if (props.value && internal.value !== props.value.address) {
      input('')
    }
  }, 500)
}
function input(value: { address: string; lat: number; lng: number } | string) {
  emit('update:modelValue', value)
}

//- TODO maybe need search by selected country autocomplete.setComponentRestrictions({ country: 'gbr' });
watch(() => props.country, (newVal: undefined | { code2: string }, oldVal: undefined | { code2: string }) => {
  if (newVal && oldVal?.code2 !== newVal?.code2) {
    autocomplete.value.setComponentRestrictions({ country: newVal.code2 })
    input('')
  }
}, {
  // deep: true,
  // immediate: true,
})


const __returned__ = { props, emit, blockClasses, internal, position, autocompleteInput, autocomplete, setupAutocomplete, blur, input, computed, ref, onMounted, onBeforeUnmount, nextTick, watch, get maps() { return maps }, get watchDebounced() { return watchDebounced } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})